module.exports = __webpack_public_path__ + "static/juicy-6c73c36231e73e68b49223592273e9db.jpg";